import { fetchJson } from './helpers';
import { PERSONALIZATION_URL } from './common';
import { type TraitsResponse } from './types';

export const getPersonalizationSiteUserTraitsUrl = (cloudId: string, userId: string) =>
	`${PERSONALIZATION_URL}/site/${cloudId}/user/${userId}`;

export const getPersonalizationSiteTraitsUrl = (cloudId: string) =>
	`${PERSONALIZATION_URL}/site/${cloudId}`;

export interface PersonalizationApiClientInterface {
	getPersonalizationSiteTraits(cloudId?: string): Promise<TraitsResponse>;
	getPersonalizationSiteUserTraits(cloudId?: string, userId?: string): Promise<TraitsResponse>;
}

export class PersonalizationClient implements PersonalizationApiClientInterface {
	public getPersonalizationSiteTraits = (cloudId: string) =>
		fetchJson<TraitsResponse>(
			getPersonalizationSiteTraitsUrl(cloudId),
			'getPeronalizationSiteTraits',
		);

	public getPersonalizationSiteUserTraits = (cloudId: string, userId: string) =>
		fetchJson<TraitsResponse>(
			getPersonalizationSiteUserTraitsUrl(cloudId, userId),
			'getPersonalizationSiteUserTraits',
		);
}

export const defaultPersonalizationClient = new PersonalizationClient();
